import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=77c87f19&scoped=true&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleModal.vue?vue&type=style&index=0&id=77c87f19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c87f19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77c87f19', component.options)
    } else {
      api.reload('77c87f19', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=77c87f19&scoped=true&", function () {
      api.rerender('77c87f19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Mantencion/VerDetalleModal.vue"
export default component.exports